// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oNLNQazzgExMQ4bOdjWL{display:grid;grid-template-columns:repeat(3, 1fr);align-items:center;justify-items:center;padding:0 16px}.Xl4br103shUNimeYL3J3{display:flex;flex-direction:column;gap:2px;width:24px}.o6f1bk6Bf5WrzK1EiJex{height:2px;background-color:#c9c9c9;border-radius:5px}.FaDcedKUFOAFJaDkEzdg{justify-self:end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "oNLNQazzgExMQ4bOdjWL",
	"barContainer": "Xl4br103shUNimeYL3J3",
	"bar": "o6f1bk6Bf5WrzK1EiJex",
	"right": "FaDcedKUFOAFJaDkEzdg"
};
export default ___CSS_LOADER_EXPORT___;
